import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchBatchDetail = createAsyncThunk("fetchBatchDetail", async ({ batchUuid, page, limit, filters }) => {
    const params = new URLSearchParams({
        page: page || 1,
        limit: limit || 50,
        distributorCode: filters?.distributorCode || "",
        status: filters?.status || "",
    });

    const response = await axiosHttp.get(`replenishment/batches/${batchUuid}?${params}`);
    return response.data;
});

export const acceptSingleSuggestion = createAsyncThunk("acceptSingleSuggestion", async (suggestionId) => {
    const response = await axiosHttp.post(`replenishment/suggestions/${suggestionId}/accept`, {});
    return response.data;
});

export const overrideSuggestion = createAsyncThunk(
    "overrideSuggestion",
    async ({ suggestionId, payload }, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.post(`replenishment/suggestions/${suggestionId}/override`, payload);
            return response.data;
        } catch (err) {
            // Forward the API error body so the UI can show the exact message
            const apiMessage = err?.response?.data?.message || err?.response?.data?.error || err.message;
            return rejectWithValue({ message: apiMessage, status: err?.response?.status });
        }
    }
);

export const tagItemSuggestion = createAsyncThunk("tagItemSuggestion", async ({ suggestionId, payload }) => {
    const response = await axiosHttp.post(`replenishment/suggestions/${suggestionId}/tag-item`, payload);
    return response.data;
});


const BatchDetailSlice = createSlice({
    name: "BatchDetailSlice",
    initialState: {
        isLoading: false,
        data: [],
        error: null,
        total: 0,
        page: 1,
        limit: 50,
        isActionLoading: false,
    },

    extraReducers: (builder) => {
        builder.addCase(fetchBatchDetail.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchBatchDetail.fulfilled, (state, action) => {
            state.isLoading = false;
            const payload = action.payload;
            const rawData = payload?.data;
            const arg = action.meta.arg;
            state.data = Array.isArray(rawData?.docs) ? rawData.docs : (Array.isArray(rawData?.data) ? rawData.data : (Array.isArray(rawData) ? rawData : []));

            const total = rawData?.totalDocs || rawData?.total || payload?.pagination?.totalRecords || payload?.total || rawData?.count;
            if (total !== undefined) state.total = total;

            state.page = rawData?.page || payload?.pagination?.currentPage || (rawData?.offset !== undefined ? Math.floor(rawData.offset / (rawData.limit || 50)) + 1 : arg.page || 1);
        });
        builder.addCase(fetchBatchDetail.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error?.message;
        });

        // Accept Single
        builder.addCase(acceptSingleSuggestion.pending, (state) => {
            state.isActionLoading = true;
        });
        builder.addCase(acceptSingleSuggestion.fulfilled, (state) => {
            state.isActionLoading = false;
        });
        builder.addCase(acceptSingleSuggestion.rejected, (state, action) => {
            state.isActionLoading = false;
            state.error = action.error?.message;
        });

        // Override Single
        builder.addCase(overrideSuggestion.pending, (state) => {
            state.isActionLoading = true;
        });
        builder.addCase(overrideSuggestion.fulfilled, (state) => {
            state.isActionLoading = false;
        });
        builder.addCase(overrideSuggestion.rejected, (state, action) => {
            state.isActionLoading = false;
            state.error = action.payload?.message || action.error?.message;
        });

        // Tag Item
        builder.addCase(tagItemSuggestion.pending, (state) => {
            state.isActionLoading = true;
        });
        builder.addCase(tagItemSuggestion.fulfilled, (state) => {
            state.isActionLoading = false;
        });
        builder.addCase(tagItemSuggestion.rejected, (state, action) => {
            state.isActionLoading = false;
            state.error = action.error?.message;
        });
    },
});

export default BatchDetailSlice.reducer;
